// extracted by mini-css-extract-plugin
export default {"AdminPage":"AdminPage_AdminPage__pqh0f","AdminPageContainer":"AdminPage_AdminPageContainer__JvLYP"};